import { RegisteredComponent } from "@builder.io/sdk-react";

import {
  BirthDateFormCtasComponent,
  SoftAgeVerificationBirthDateFormInputsComponent,
  SoftAgeVerificationDisclaimerComponent,
} from "@/components/SoftAgeVerification";

export const softAgeVerificationComponents: RegisteredComponent[] = [
  SoftAgeVerificationBirthDateFormInputsComponent,
  SoftAgeVerificationDisclaimerComponent,
  BirthDateFormCtasComponent,
];
